import { useOthers } from "../../liveblocks.config";
import React from "react";

export const CURSOR_COLORS = [
  "#E57373",
  "#9575CD",
  "#4FC3F7",
  "#81C784",
  "#FFF176",
  "#FF8A65",
  "#F06292",
  "#7986CB",
];

type CursorProps = {
  color: string;
  x: number;
  y: number;
  width: number;
  height: number;
  canvasWidth: number;
  canvasHeight: number;
};

const Cursor = ({
  color,
  x,
  y,
  width,
  height,
  canvasWidth,
  canvasHeight,
}: CursorProps) => {
  const transformX = canvasWidth / 2 + x;
  const transformY = canvasHeight / 2 + y;
  return (
    <div
      style={{
        position: "absolute",
        top: "0",
        left: "0",
        transform: `translate(${transformX}px, ${transformY}px)`,
        transition: "transform 0ms linear",
        zIndex: "10000",
      }}
    >
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.65376 12.3673H5.46026L5.31717 12.4976L0.500002 16.8829L0.500002 1.19841L11.7841 12.3673H5.65376Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

type AllCursorProps = {
  canvasWidth: number;
  canvasHeight: number;
  zoomPerc: number;
};

const AllCursors = ({
  canvasWidth,
  canvasHeight,
  zoomPerc,
}: AllCursorProps) => {
  let users: any = useOthers();

  return (
    <>
      {users.map(({ connectionId, presence }) => {
        if (!presence.cursor) {
          return null;
        }

        return (
          <Cursor
            key={`cursor-${connectionId}`}
            // connectionId is an integer that is incremented at every new connections
            // Assigning a color with a modulo makes sure that a specific user has the same colors on every clients
            color={CURSOR_COLORS[connectionId % CURSOR_COLORS.length]}
            x={presence.cursor?.x}
            y={presence.cursor?.y}
            width={80 / (zoomPerc * 0.5)}
            height={80 / (zoomPerc * 0.5)}
            canvasHeight={canvasHeight}
            canvasWidth={canvasWidth}
          />
        );
      })}
    </>
  );
};

export default React.memo(AllCursors);
